// Find the tail step of a subgraph: the first step whose exit leaves the subgraph
// (or is absent). Falls back to the subgraph root when none qualifies.
export const getLastStepInSubgraph = (subgraph, graph) => {
  for (const stepId of subgraph.steps) {
    const node = graph[stepId];
    if (!node?.exit || !subgraph.steps.includes(node.exit)) {
      return stepId;
    }
  }

  return subgraph.root;
};
